import StandaloneChat from './standalone-chat'

export default StandaloneChat